import React from "react";
import { useNavigate } from "react-router-dom";
import "./landing.css";

function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className="landing-footer">
      <div className="landing-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">classBoon</div>
            <p>
              A simple, real-time platform for student sign-outs, attendance, and
              emergency accountability — built by a teacher, for teachers.
            </p>
          </div>

          <div className="footer-col">
            <h4>Features</h4>
            {/* Real hrefs: these are pre-rendered static pages (see
                scripts/build-marketing-pages.js), served outside the SPA. */}
            <a href="/digital-hall-pass">Digital hall pass</a>
            <a href="/classroom-attendance">Classroom attendance</a>
            <a href="/classroom-library">Classroom library</a>
            <a href="/emergency-roll-call">Emergency roll call</a>
          </div>

          <div className="footer-col">
            <h4>Product</h4>
            <button type="button" onClick={() => navigate("/about")}>
              How it works
            </button>
            <button type="button" onClick={() => navigate("/register")}>
              Create account
            </button>
            <button type="button" onClick={() => navigate("/loginform")}>
              Sign in
            </button>
          </div>

          <div className="footer-col">
            <h4>For students</h4>
            <a href="https://students.classboon.com">Student sign-out</a>
            <button type="button" onClick={() => navigate("/about")}>
              About classBoon
            </button>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <button type="button" onClick={() => navigate("/support")}>
              Support
            </button>
            <button type="button" onClick={() => navigate("/privacy")}>
              Privacy Policy
            </button>
            <button type="button" onClick={() => navigate("/terms")}>
              Terms of Service
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          © {year} classBoon · Made for classrooms.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
